export const COMPANY_NAME = "BAMCCUL ONLINE"
export const COMPANY_NAME_FULL = "BAMCCUL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "BAMCCUL ONLINE"
export const META_DESCRIPTION = "Welcome to BAMCCUL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://bamcculonline.com"
export const ENABLE_OTHER_DEPOSIT = false
